var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatEmojisIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.2 48.2",
    style: {
      enableBackground: "new 0 0 48.2 48.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6F300;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2,24.1c0,13.3-10.8,24.1-24.1,24.1S0,37.4,0,24.1S10.8,0,24.1,0S48.2,10.8,48.2,24.1z M16.4,13.9 c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3S18.8,13.9,16.4,13.9z M31.9,13.9c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3 s4.3-1.9,4.3-4.3S34.3,13.9,31.9,13.9z M31.7,30.6c-2,1.8-4.7,2.8-7.6,2.8c-2.8,0-5.4-1-7.5-2.7l-0.9-0.8c-0.3-0.2-0.5-0.3-1.1-0.3 c-1.1,0-1.9,0.9-1.9,1.9c0,0.5,0.2,1,0.6,1.4l0.7,0.6c2.7,2.4,6.3,3.8,10.1,3.8c3.9,0,7.5-1.5,10.2-3.9l0.5-0.5 c0.4-0.4,0.6-0.9,0.6-1.4c0-1.1-0.9-1.9-1.9-1.9c-0.5,0-0.9,0.2-1.2,0.4L31.7,30.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEmojisIcon);
export default __webpack_public_path__ + "static/media/chat_emojis_icon.4964b1f6c5621ac14fe26cb7b52ca3b6.svg";
export { ForwardRef as ReactComponent };